export const START_DRIVER_STATS_GAME_COMPLETED = "driverStats/START_GAME_COMPLETED";
export const SUBMIT_DRIVER_STATS_GAME_COMPLETED = "driverStats/SUBMIT_GAME_COMPLETED";
